import e from "./CurrentRefinements.vue_rollup-plugin-vue=script.js";
export default (function (e, t, n, r, i, s, a, u) {
  var l = ("function" == typeof n ? n.options : n) || {};
  return l.__file = "CurrentRefinements.vue", l.render || (l.render = e.render, l.staticRenderFns = e.staticRenderFns, l._compiled = !0, i && (l.functional = !0)), l._scopeId = r, l;
})({
  render: function render() {
    var e = this,
        t = e.$createElement,
        n = e._self._c || t;
    return e.state ? n("div", {
      class: [e.suit(), e.noRefinement && e.suit("", "noRefinement")]
    }, [e._t("default", function () {
      return [n("ul", {
        class: e.suit("list")
      }, e._l(e.state.items, function (t) {
        return n("li", {
          key: t.attribute,
          class: e.suit("item")
        }, [e._t("item", function () {
          return [n("span", {
            class: e.suit("label")
          }, [e._v(e._s(e.capitalize(t.label)) + ": ")]), e._v(" "), e._l(t.refinements, function (r) {
            return n("span", {
              key: e.createItemKey(r),
              class: e.suit("category")
            }, [e._t("refinement", function () {
              return [n("span", {
                class: e.suit("categoryLabel")
              }, ["query" === r.attribute ? n("q", [e._v(e._s(r.label))]) : [e._v(e._s(r.label))]], 2), n("button", {
                class: e.suit("delete"),
                attrs: {
                  type: "button"
                },
                on: {
                  click: function click(n) {
                    return !n.type.indexOf("key") && e._k(n.keyCode, "left", 37, n.key, ["Left", "ArrowLeft"]) ? null : "button" in n && 0 !== n.button ? null : n.ctrlKey || n.shiftKey || n.altKey || n.metaKey ? null : t.refine(r);
                  }
                }
              }, [e._v("\n                ✕\n              ")])];
            }, {
              refine: t.refine,
              refinement: r,
              createURL: e.state.createURL
            })], 2);
          })];
        }, {
          refine: t.refine,
          item: t,
          createURL: e.state.createURL
        })], 2);
      }), 0)];
    }, {
      refine: e.state.refine,
      items: e.state.items,
      createURL: e.state.createURL
    })], 2) : e._e();
  },
  staticRenderFns: []
}, 0, e, void 0, !1);